import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, XMarkIcon, } from '@heroicons/react/24/solid';
const iconClasses = 'h-6 w-6 flex-shrink-0';
const bgClasses = {
    success: 'bg-green-50 border-green-400 text-green-700',
    error: 'bg-red-50 border-red-400 text-red-700',
    info: 'bg-blue-50 border-blue-400 text-blue-700',
};
const icons = {
    success: CheckCircleIcon,
    error: ExclamationCircleIcon,
    info: InformationCircleIcon,
};
const Toast = ({ id, message, type = 'info', duration = 5000, onClose, }) => {
    const [visible, setVisible] = useState(true);
    const timerRef = useRef(null);
    useEffect(() => {
        timerRef.current = setTimeout(() => {
            setVisible(false);
            setTimeout(() => onClose(id), 300);
        }, duration);
        return () => {
            if (timerRef.current)
                clearTimeout(timerRef.current);
        };
    }, [duration, id, onClose]);
    if (!visible)
        return null;
    const Icon = icons[type];
    return (_jsxs("div", { className: `pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded border p-3 shadow-lg transition-opacity duration-300 ${bgClasses[type]}`, role: "alert", "aria-live": "assertive", "aria-atomic": "true", children: [_jsx(Icon, { className: iconClasses, "aria-hidden": "true" }), _jsx("div", { className: "flex-1 text-sm font-medium", children: message }), _jsx("button", { onClick: () => setVisible(false), className: "text-sm text-gray-500 hover:text-gray-700", "aria-label": "Close notification", children: _jsx(XMarkIcon, { className: "h-5 w-5", "aria-hidden": "true" }) })] }));
};
export default Toast;
